"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableList = void 0;
var _react = _interopRequireWildcard(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _RichText = require("../RichText");
var _context = require("../ConfigProvider/context");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

// import sanitizeHtml from 'sanitize-html';
// import defaultOptions from '../../constants/sanitizeHtmlOptions';
var TableList = function TableList(props) {
  var _props$dataList = props.dataList,
    dataList = _props$dataList === void 0 ? [] : _props$dataList;
  var context = (0, _react.useContext)(_context.ConfigContext);
  var onClose = function onClose() {
    var _context$eventEmitter, _context$eventEmitter2;
    context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, 'closeGlobalModal');
  };
  var TableListItem = function TableListItem(itemData, index) {
    var title = itemData.title,
      content = itemData.content;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: (0, _getPrefixCls.getPrefixCls)('table-list-item')
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _getPrefixCls.getPrefixCls)('table-list-item-title')
    }, title), /*#__PURE__*/_react.default.createElement(_RichText.RichText, {
      content: content,
      className: (0, _getPrefixCls.getPrefixCls)('table-list-item-content'),
      onClose: onClose
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('table-list-container')
  }, dataList.map(function (data, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: (0, _getPrefixCls.getPrefixCls)('table-list')
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _getPrefixCls.getPrefixCls)('table-list-title')
    }, data.title), data.groupData.map(function (itemData, itemIndex) {
      return TableListItem(itemData, itemIndex);
    }));
  }));
};
exports.TableList = TableList;